import * as React from 'react';

import {
  designerTheme,
  styledDiv,
  emotionStyled,
} from '@packages/utilities/styled';

import {noEmpty} from '@packages/utilities/component';

import clickable from './logic/clickable';
import {default as TooltipTrigger, KeepToolTipTrigger} from './TooltipTrigger';
import Hitarea from './Hitarea';
import {InfoIcon} from '@packages/systems/spring';

const InlineFlexRow = emotionStyled('span')({
  display: 'inline-flex',
  alignItems: 'center',
});

const ButtonContainer = noEmpty(
  clickable(
    styledDiv(
      ({theme, cursor}) => ({
        color: theme.colors.foregroundDimmer,
        transition: 'color 0.1s ease',
        display: 'inline-flex',
        position: 'relative',
        cursor,
      }),
      {
        hover: ({theme}) => ({color: theme.colors.foregroundDim}),
      }
    )
  )
);

/**
 * @deprecated use `Tooltip` from `@packages/systems/spring` instead
 */
const TooltipControl = ({
  iconStyle = {
    padding: designerTheme.gutters.base,
    boxSizing: 'content-box',
  },
  icon = <InfoIcon style={iconStyle} />,
  cursor = 'help',
  placement = 'bottom',
  children,
  hideOnClick,
  style,
  automationLabel = 'tooltip',
  ...rest
}) => {
  const Trigger = hideOnClick ? TooltipTrigger : KeepToolTipTrigger;
  return (
    <InlineFlexRow style={style}>
      <Trigger placement={placement} {...rest}>
        <Hitarea>
          <ButtonContainer cursor={cursor} data-automation-id={automationLabel}>
            {icon}
            {children}
          </ButtonContainer>
        </Hitarea>
      </Trigger>
    </InlineFlexRow>
  );
};

/*
interface TooltipControlProps {
  content: string | React.ReactNode;
  icon?: React.ReactElement;
  iconStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  cursor?: string;
  placement?: string;
  primary?: boolean;
  success?: boolean;
  warning?: boolean;
  error?: boolean;
  automationLabel?: string;
}
*/

TooltipControl.displayName = 'TooltipControl';
export default React.memo(TooltipControl);
